// eslint-disable-next-line no-shadow
export var PriceVariantType = /*#__PURE__*/function (PriceVariantType) {
  PriceVariantType["SMALL"] = "small";
  PriceVariantType["MEDIUM"] = "medium";
  PriceVariantType["LARGE"] = "large";
  return PriceVariantType;
}({});